import { createSlice } from "@reduxjs/toolkit";
import _ from 'lodash';

const initialState = {
   tasks: {},
   activeTaskList: null
}

const AiTasksSlice = createSlice({
  name: 'aiTasks',
  initialState,
  reducers: {
    resetTasks(state, action) {
        state.tasks = {};
        state.activeTaskList = null;
    },
    setTasks(state, action) {
        const {tasks, activeTaskList} = action.payload;
        state.activeTaskList = activeTaskList;
        state.tasks = {...state.tasks, [activeTaskList]: tasks};
    },
    setActiveTasks(state, action) {
        state.tasks[state.activeTaskList] = action.payload;
    },
    setActiveTaskList(state, action) {
        state.activeTaskList = action.payload;
    }
  }
})


// reducers exports
export const {resetTasks, setTasks, setActiveTasks, setActiveTaskList} = AiTasksSlice.actions;

export default AiTasksSlice.reducer;